<template>
  <screen-locker>
    <template v-slot:content>
      <div
        class="page d-flex flex-column align-items-start flex-fill"
        v-if="!showLoadingNextStep"
      >
        <AppHeader :step-active="6"></AppHeader>
        <div class="row header-page w-100">
          <div class="col">
            <h3>
              &nbsp;
            </h3>
            <div class="row h-100">
              <div class="col h-100">
                <div class="banner banner-area h-100">
                  <div
                    class="svg-banner-area w-100 h-100 d-flex align-items-center"
                    v-bind:class="getBannerAreaClasses()"
                  >
                    <svg-viewer
                      :static-call="true"
                      :src="imageBanner"
                      :height="window.width <= 1440 ? '350px' : '430px'"
                      width="100%"
                    ></svg-viewer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-data mt-3 w-100" style="min-height: 170px">
          <div class="col w-100">
            <div class="d-flex flex-row summary">
              <div
                class="summary-icon svg-banner-extra-protections"
                v-bind:class="getBannerUserClasses()"
              >
                <svg-viewer
                  :src="require('../assets/images/banner/07-cross.svg')"
                  height="130px"
                  width="130px"
                ></svg-viewer>
              </div>
              <div class="row w-100">
                <div class="col-6">
                  <span class="summary-info"
                    >Premio versato
                    <strong>{{ $store.state.capitalValue | currency }}</strong
                    ><br />
                    con periodo di osservazione
                    <strong>{{ $store.state.yearValue }} anni</strong>
                  </span>
                </div>
                <div class="col-6">
                  Prima della sottoscrizione leggere il set informativo
                  disponibile su generali.it e in agenzia.
                </div>
                <div class="col">
                  <div class="d-flex flex-row contribs-list mt-2">
                    <div
                      v-for="(area, index) in areaList"
                      v-bind:key="area.id"
                      class="w-20"
                      v-bind:class="[
                        index !== areaList.length - 1 ? 'mr-4' : '',
                        index !== areaList.length - 1 ? 'mr-xl-5' : ''
                      ]"
                    >
                      <div class="sdg-title">{{ area.title }}</div>
                      <div class="sdg-item">
                        <img
                          v-for="sdg in area.sdg"
                          v-bind:key="sdg.id"
                          :src="sdg.icon"
                          :alt="sdg.title"
                          class="mr-2 mb-2 mt-1"
                        />
                      </div>
                      <div
                        v-for="(contrib, j) in area.contribs"
                        :key="index + '_' + j"
                        :title="contrib.title"
                        :id="'imgContrib_' + area.id + '_' + contrib.id"
                        class="contrib-item"
                      >
                        <img :src="contrib.icon" />
                        <b-popover
                          :target="'imgContrib_' + area.id + '_' + contrib.id"
                          triggers="hover"
                          placement="top"
                        >
                          <div
                            class="contrib-popoper-title mb-2"
                            v-bind:style="{ color: area.color }"
                          >
                            {{ contrib.title }}
                          </div>
                          <div
                            class="contrib-popoper-text"
                            v-dompurify-html="contrib.text"
                          ></div>
                        </b-popover>
                      </div>
                    </div>
                    <template v-if="false">
                      <template v-for="(area, index) in areaList">
                        <div
                          v-for="(contrib, j) in area.contribs"
                          :key="index + '_' + j"
                          :title="contrib.title"
                          :id="'imgContrib_' + area.id + '_' + contrib.id"
                          class="contrib-item"
                        >
                          <img :src="contrib.icon" />
                          <b-popover
                            :target="'imgContrib_' + area.id + '_' + contrib.id"
                            triggers="hover"
                            placement="top"
                          >
                            <div
                              class="contrib-popoper-title mb-2"
                              v-bind:style="{ color: area.color }"
                            >
                              {{ contrib.title }}
                            </div>
                            <div
                              class="contrib-popoper-text"
                              v-dompurify-html="contrib.text"
                            ></div>
                          </b-popover>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex footer-page w-100">
          <b-button variant="link" @click="back()">
            <img alt="Indietro" src="../assets/images/back.svg" />
            Indietro
          </b-button>
          <b-button variant="primary ml-auto" @click="processData()"
            >Invia al cliente</b-button
          >
        </div>
        <b-modal
          v-model="modal"
          adaptive="true"
          title="Salva Simulazione"
          dialog-class="modal-full"
          hide-footer
        >
          <template v-slot:modal-header>
            &nbsp;
            <b-button
              variant="link modal-close"
              size="sm"
              class="float-right"
              @click="modal = false"
            >
              <img src="../assets/images/close.svg" alt="Chiudi" />
            </b-button>
          </template>
          <b-container style="height: 80vh">
            <SaveSimulationForm v-if="modal"></SaveSimulationForm>
          </b-container>
        </b-modal>
        <auth-guard />
      </div>
      <loading-page
        v-if="showLoadingNextStep"
        :timeout="2000"
        show-class="show-spin-02"
        @closed="showModal()"
      ></loading-page>
    </template>
  </screen-locker>
</template>

<script>
import router from "../router";
// import { resetState } from "../helpers/store.utils";
import SaveSimulationForm from "./modals/SaveSimulationForm";
import { ExtraProtectionData } from "../data/extra-protection.data";
import { getAreaListData } from "../data/area-list.data";
import LoadingPage from "../components/LoadingPage";
export default {
  name: "Summary",
  components: { LoadingPage, SaveSimulationForm },
  data: () => {
    return {
      modal: false,
      areaList: [],
      extraProtectionList: [],
      imageBanner: null,
      window: {
        width: 0,
        height: 0
      },
      showLoadingNextStep: false
    };
  },
  created() {
    this.areaList = JSON.parse(
      JSON.stringify(getAreaListData(this.$store.state.areaValue))
    );
    this.extraProtectionList = JSON.parse(JSON.stringify(ExtraProtectionData));

    this.areaList = this.areaList.filter(
      a => this.$store.state.areaValue.filter(sa => sa.id === a.id).length > 0
    );
    this.extraProtectionList.filter(a => {
      if (
        this.$store.state.extraProtectionValue.filter(e => e.id === a.id)
          .length > 0
      ) {
        a.model.selected = true;
        a.model.value = this.$store.state.extraProtectionValue.filter(
          e => e.id === a.id
        )[0].value;
      }
    });
    this.imageBanner = this.getBannerImage();
  },
  methods: {
    processData() {
      // router.push("/");
      // resetState();
      // this.showLoadingNextStep = true;
      this.showModal();
    },
    showModal() {
      this.showLoadingNextStep = false;
      this.modal = true;
    },
    back() {
      router.push("scenario");
    },
    getBannerAreaClasses() {
      const result = [];
      let className = "";

      const selected = JSON.parse(JSON.stringify(this.areaList)).sort((a, b) =>
        a.id < b.id ? -1 : a.id > b.id ? 1 : 0
      );
      className = `svg-area-${
        selected.length > 0 ? selected.map(a => a.svgClass).join("") : "none"
      }`;
      result.push(className);

      return result;
    },
    getBannerUserClasses() {
      const result = [];
      let className = "";

      const generaliPiuClass = this.$store.state.generaliPlusValue
        ? "svg-piu-generali"
        : "";
      className = `svg-${this.$store.state.genderValue.toLocaleLowerCase()}-${
        this.$store.state.ageValue
      } ${generaliPiuClass}`;
      result.push(className);
      this.extraProtectionList.filter(e => {
        if (e.model.selected) {
          className = `svg-${e.svgClass}`;
          result.push(className);
        }
      });

      return result;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getBannerImage() {
      const selected = this.areaList.sort((a, b) =>
        a.id < b.id ? -1 : a.id > b.id ? 1 : 0
      );
      const dir = this.window.width <= 1440 ? "main" : "wide";
      const imgName =
        selected.length > 0 ? selected.map(a => a.svgClass).join("") : "Z";
      const path = `./images/banner/02/${dir}/${imgName}.svg`;
      return path;
    }
  }
};
</script>

<style scoped></style>
